import { render } from "./DocumentsFolderViewAddEditFolderModal.vue?vue&type=template&id=08eb1efe"
import script from "./DocumentsFolderViewAddEditFolderModal.vue?vue&type=script&lang=js"
export * from "./DocumentsFolderViewAddEditFolderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__